export const isInAppBrowser = () => {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  return /WhatsApp|FBAN|FBAV|FB_IAB|Instagram|Telegram|LinkedInApp|Snapchat|Twitter|Line\//i.test(ua);
};

// Detects phones/tablets (Android, iOS incl. iPadOS) so we route them to the
// hosted checkout page which supports UPI Intent, instead of the pop-up modal.
export const isMobileDevice = () => {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  const isTouchMac = navigator.platform === "MacIntel" && (navigator.maxTouchPoints || 0) > 1;
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(ua) || isTouchMac;
};

export const copyPageLink = async () => {
  try {
    await navigator.clipboard.writeText(window.location.href);
    return true;
  } catch {
    return false;
  }
};
